export default function dateFormatter(cell) {
    return new Date(cell).toLocaleDateString()
}
